import _classCallCheck from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _asyncToGenerator from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["passwordConfirmation", "confirmSuccessUrl"],
    _excluded2 = ["redirectUrl"],
    _excluded3 = ["currentPassword", "password", "passwordConfirmation"],
    _excluded4 = ["SessionHandler", "isServer"],
    _excluded5 = ["SessionHandler", "getState", "dispatch", "headerKeys", "confirmationKeys", "reducerName", "userType", "location", "redirect", "onConfirmSuccess", "onConfirmError", "mapUrlCredsToHeaders", "requestCookies", "setResponseCookie", "clearResponseCookie", "endpointConfig", "isServer"],
    _excluded6 = ["headers"];
import _regeneratorRuntime from "/opt/build/repo/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Axios } from 'axios';
import { isEmpty, isArray, defaultsDeep, get, pick } from 'lodash';
import qs from 'qs';
import { BaseSessionHandler, ServerSessionHandler, CookieSessionHandler } from './session';
import { OAuthBrowserWindow } from './oauth';
import { UPDATE_USER, INVALID_CREDS, VALIDATE_TOKEN_START, VALIDATE_TOKEN_SUCCESS, VALIDATE_TOKEN_ERROR, EMAIL_SIGNUP_START, EMAIL_SIGNUP_SUCCESS, EMAIL_SIGNUP_ERROR, EMAIL_SIGNIN_START, EMAIL_SIGNIN_SUCCESS, EMAIL_SIGNIN_ERROR, SIGN_OUT_START, SIGN_OUT_SUCCESS, SIGN_OUT_ERROR, OAUTH_SIGNIN_START, OAUTH_SIGNIN_SUCCESS, OAUTH_SIGNIN_ERROR, PASSWORD_RESET_REQUEST_START, PASSWORD_RESET_REQUEST_SUCCESS, PASSWORD_RESET_REQUEST_ERROR, PASSWORD_UPDATE_START, PASSWORD_UPDATE_SUCCESS, PASSWORD_UPDATE_ERROR } from './constants';
export var defaultHeaderKeys = ['access-token', 'uid', 'client', 'expiry'];
export var defaultConfirmationKeys = {
  emailSignUp: 'account_confirmation_success',
  paswordReset: 'password_reset_success',
  client: 'client_id',
  'access-token': 'token',
  expiry: 'expiry',
  uid: 'uid',
  config: 'config',
  reset_password: 'reset_password',
  oauth_registration: 'oauth_registration'
};
export var endpointDefaults = {
  base: 'auth',
  validateToken: {
    path: '/validate_token',
    method: 'get',
    formatSuccessResponse: function formatSuccessResponse(_ref) {
      var data = _ref.data;
      return data;
    },
    formatErrorResponse: function formatErrorResponse(_ref2) {
      var errors = _ref2.errors;
      return errors;
    }
  },
  emailSignUp: {
    path: '',
    method: 'post',
    formatBody: function formatBody(_ref3) {
      var passwordConfirmation = _ref3.passwordConfirmation,
          confirmSuccessUrl = _ref3.confirmSuccessUrl,
          body = _objectWithoutProperties(_ref3, _excluded);

      return _objectSpread({
        password_confirmation: passwordConfirmation,
        confirm_success_url: confirmSuccessUrl
      }, body);
    },
    formatSuccessResponse: function formatSuccessResponse(_ref4) {
      var data = _ref4.data;
      return data;
    },
    formatErrorResponse: function formatErrorResponse(resp) {
      return {
        _error: isArray(resp) ? resp : get(resp, 'errors.full_messages'),
        email: get(resp, 'errors.email'),
        password: get(resp, 'errors.password'),
        passwordConfirmation: get(resp, 'errors.password_confirmation')
      };
    }
  },
  emailSignIn: {
    path: '/sign_in',
    method: 'post',
    formatBody: function formatBody(body) {
      return body;
    },
    formatSuccessResponse: function formatSuccessResponse(_ref5) {
      var data = _ref5.data;
      return data;
    },
    formatErrorResponse: function formatErrorResponse(resp) {
      return {
        _error: get(resp, 'errors')
      };
    }
  },
  oAuthSignIn: {
    facebook: '/facebook',
    github: '/github',
    google: '/google'
  },
  signOut: {
    path: '/sign_out',
    method: 'delete',
    formatErrorResponse: function formatErrorResponse(resp) {
      return {
        _error: get(resp, 'errors')
      };
    }
  },
  passwordResetRequest: {
    path: '/password',
    method: 'post',
    formatBody: function formatBody(_ref6) {
      var redirectUrl = _ref6.redirectUrl,
          body = _objectWithoutProperties(_ref6, _excluded2);

      return _objectSpread({
        redirect_url: redirectUrl
      }, body);
    },
    formatErrorResponse: function formatErrorResponse(resp) {
      return {
        _error: get(resp, 'errors')
      };
    }
  },
  passwordUpdate: {
    path: '/password',
    method: 'put',
    formatBody: function formatBody(_ref7) {
      var currentPassword = _ref7.currentPassword,
          password = _ref7.password,
          passwordConfirmation = _ref7.passwordConfirmation,
          body = _objectWithoutProperties(_ref7, _excluded3);

      return _objectSpread({
        current_password: currentPassword,
        password: password,
        password_confirmation: passwordConfirmation
      }, body);
    },
    formatErrorResponse: function formatErrorResponse(resp) {
      var _get, _get2, _get3;

      return {
        _error: isArray(resp === null || resp === void 0 ? void 0 : resp.errors) ? resp === null || resp === void 0 ? void 0 : resp.errors : get(resp, 'errors.full_messages'),
        currentPassword: (_get = get(resp, 'errors.current_password', [])) === null || _get === void 0 ? void 0 : _get.map(function (err) {
          return "Current password ".concat(err);
        }),
        password: (_get2 = get(resp, 'errors.password', [])) === null || _get2 === void 0 ? void 0 : _get2.map(function (err) {
          return "Password ".concat(err);
        }),
        passwordConfirmation: (_get3 = get(resp, 'errors.password_confirmation', [])) === null || _get3 === void 0 ? void 0 : _get3.map(function (err) {
          return "Password confirmation ".concat(err);
        })
      };
    }
  }
};
export function defaultMapUrlCredsToHeaders(_ref8) {
  var token = _ref8.token,
      client_id = _ref8.client_id,
      expiry = _ref8.expiry,
      uid = _ref8.uid;
  return {
    'access-token': token,
    client: client_id,
    expiry: expiry,
    uid: uid
  };
} // watch api responses for updated creds, save those creds to the session

export function updateCreds(_x) {
  return _updateCreds.apply(this, arguments);
} // append creds saved in the session to outbound api requests

function _updateCreds() {
  _updateCreds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref9) {
    var session, response, headerKeys, creds;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            session = _ref9.session, response = _ref9.response, headerKeys = _ref9.headerKeys;
            creds = pick(response.headers, headerKeys);

            if (!(!isEmpty(creds) && creds['access-token'])) {
              _context8.next = 5;
              break;
            }

            _context8.next = 5;
            return session.set(creds);

          case 5:
            return _context8.abrupt("return", response);

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _updateCreds.apply(this, arguments);
}

export function appendCreds(_x2) {
  return _appendCreds.apply(this, arguments);
}

function _appendCreds() {
  _appendCreds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref10) {
    var session, request, creds, headers, config, nextConfig;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            session = _ref10.session, request = _ref10.request;
            _context9.next = 3;
            return session.get();

          case 3:
            creds = _context9.sent;
            headers = request.headers, config = _objectWithoutProperties(request, _excluded6);
            nextConfig = defaultsDeep({
              headers: creds || {}
            }, config);
            return _context9.abrupt("return", nextConfig);

          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _appendCreds.apply(this, arguments);
}

export function initSession(_ref11) {
  var SessionHandler = _ref11.SessionHandler,
      isServer = _ref11.isServer,
      opts = _objectWithoutProperties(_ref11, _excluded4);

  var session; // if sessionHandler is provided, use it.

  if (SessionHandler) {
    // ensure session handler implements base class
    if (SessionHandler.prototype instanceof BaseSessionHandler) {
      session = new SessionHandler(opts);
    } else {
      throw new Error('Invalid SessionHandler. It must inherit from BaseSessionHandler');
    }
  } else if (isServer()) {
    // we're on the server. default to memory as the store
    session = new ServerSessionHandler(opts);
  } else {
    // we're on the client. default to localStorage
    session = new CookieSessionHandler(opts);
  }

  return session;
}

function isServerDefault() {
  return !(true && window.document);
}

var AuthClient = /*#__PURE__*/function (_Axios) {
  _inherits(AuthClient, _Axios);

  var _super = _createSuper(AuthClient);

  function AuthClient() {
    var _this;

    var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var SessionHandler = _ref12.SessionHandler,
        getState = _ref12.getState,
        dispatch = _ref12.dispatch,
        _ref12$headerKeys = _ref12.headerKeys,
        headerKeys = _ref12$headerKeys === void 0 ? defaultHeaderKeys : _ref12$headerKeys,
        _ref12$confirmationKe = _ref12.confirmationKeys,
        confirmationKeys = _ref12$confirmationKe === void 0 ? defaultConfirmationKeys : _ref12$confirmationKe,
        _ref12$reducerName = _ref12.reducerName,
        reducerName = _ref12$reducerName === void 0 ? 'auth' : _ref12$reducerName,
        _ref12$userType = _ref12.userType,
        userType = _ref12$userType === void 0 ? 'user' : _ref12$userType,
        location = _ref12.location,
        _ref12$redirect = _ref12.redirect,
        redirect = _ref12$redirect === void 0 ? function () {} : _ref12$redirect,
        onConfirmSuccess = _ref12.onConfirmSuccess,
        onConfirmError = _ref12.onConfirmError,
        _ref12$mapUrlCredsToH = _ref12.mapUrlCredsToHeaders,
        mapUrlCredsToHeaders = _ref12$mapUrlCredsToH === void 0 ? defaultMapUrlCredsToHeaders : _ref12$mapUrlCredsToH,
        requestCookies = _ref12.requestCookies,
        setResponseCookie = _ref12.setResponseCookie,
        clearResponseCookie = _ref12.clearResponseCookie,
        _ref12$endpointConfig = _ref12.endpointConfig,
        endpointConfig = _ref12$endpointConfig === void 0 ? {} : _ref12$endpointConfig,
        _ref12$isServer = _ref12.isServer,
        isServer = _ref12$isServer === void 0 ? isServerDefault : _ref12$isServer,
        axiosOpts = _objectWithoutProperties(_ref12, _excluded5);

    _classCallCheck(this, AuthClient);

    _this = _super.call(this, _objectSpread({
      paramsSerializer: function paramsSerializer(params) {
        return qs.stringify(params, {
          arrayFormat: 'brackets'
        });
      }
    }, axiosOpts)); // extend endpoint base config with overrides

    _this.endpointConfig = defaultsDeep(endpointConfig, endpointDefaults);
    _this.dispatch = dispatch;
    _this.userType = userType; // initialize auth session

    _this.session = initSession({
      client: _assertThisInitialized(_this),
      SessionHandler: SessionHandler,
      getState: getState,
      headerKeys: headerKeys,
      confirmationKeys: confirmationKeys,
      reducerName: reducerName,
      userType: userType,
      location: location,
      redirect: redirect,
      onConfirmSuccess: onConfirmSuccess,
      onConfirmError: onConfirmError,
      mapUrlCredsToHeaders: mapUrlCredsToHeaders,
      requestCookies: requestCookies,
      setResponseCookie: setResponseCookie,
      clearResponseCookie: clearResponseCookie,
      isServer: isServer,
      validateToken: function validateToken() {
        return _this.validateToken();
      },
      dispatchAction: function dispatchAction() {
        var _this2;

        return (_this2 = _this).dispatchAction.apply(_this2, arguments);
      }
    }); // move session init promise to base client instance for convenience

    _this.isInitialized = _this.session.isInitialized; // add session interceptors

    _this.interceptors.request.use(function (request) {
      return appendCreds({
        session: _this.session,
        request: request
      });
    });

    _this.interceptors.response.use(function (response) {
      return updateCreds({
        headerKeys: headerKeys,
        session: _this.session,
        response: response
      });
    });

    return _this;
  }

  _createClass(AuthClient, [{
    key: "dispatchAction",
    value: function dispatchAction() {
      var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          type = _ref13.type,
          payload = _ref13.payload;

      if (!this.dispatch) {
        return;
      }

      this.dispatch({
        type: type,
        payload: payload,
        userType: this.userType
      });
    }
  }, {
    key: "validateToken",
    value: function () {
      var _validateToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$endpointConfig, base, _this$endpointConfig$, method, path, formatSuccessResponse, _yield$this$method, data, payload, message, _payload;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$endpointConfig = this.endpointConfig, base = _this$endpointConfig.base, _this$endpointConfig$ = _this$endpointConfig.validateToken, method = _this$endpointConfig$.method, path = _this$endpointConfig$.path, formatSuccessResponse = _this$endpointConfig$.formatSuccessResponse;
                this.dispatchAction({
                  type: VALIDATE_TOKEN_START
                });
                _context.prev = 2;
                _context.next = 5;
                return this[method]("".concat(base).concat(path));

              case 5:
                _yield$this$method = _context.sent;
                data = _yield$this$method.data;
                payload = formatSuccessResponse(data); // update store with user data

                this.dispatchAction({
                  type: UPDATE_USER,
                  payload: payload
                });
                this.dispatchAction({
                  type: VALIDATE_TOKEN_SUCCESS
                });
                return _context.abrupt("return", payload);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);
                // dispatch notification of invalid creds
                message = 'Invalid credentials.';
                _payload = {
                  message: message,
                  error: _context.t0
                };
                this.dispatchAction({
                  type: INVALID_CREDS,
                  payload: _payload
                }); // remove bad credentials from session

                _context.next = 20;
                return this.session.clear();

              case 20:
                this.dispatchAction({
                  type: VALIDATE_TOKEN_ERROR
                });
                throw new Error(message);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 13]]);
      }));

      function validateToken() {
        return _validateToken.apply(this, arguments);
      }

      return validateToken;
    }()
  }, {
    key: "emailSignUp",
    value: function () {
      var _emailSignUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(body) {
        var _this$endpointConfig2, base, _this$endpointConfig3, method, path, formatBody, formatSuccessResponse, formatErrorResponse, resp, data, payload, creds, err, errors, _payload2, error;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$endpointConfig2 = this.endpointConfig, base = _this$endpointConfig2.base, _this$endpointConfig3 = _this$endpointConfig2.emailSignUp, method = _this$endpointConfig3.method, path = _this$endpointConfig3.path, formatBody = _this$endpointConfig3.formatBody, formatSuccessResponse = _this$endpointConfig3.formatSuccessResponse, formatErrorResponse = _this$endpointConfig3.formatErrorResponse;
                this.dispatchAction({
                  type: EMAIL_SIGNUP_START
                });
                _context2.prev = 2;
                _context2.next = 5;
                return this[method]("".concat(base).concat(path), formatBody(_objectSpread({
                  config_name: this.userType
                }, body)));

              case 5:
                resp = _context2.sent;
                data = get(resp, 'data', {});
                payload = formatSuccessResponse(data);
                _context2.next = 10;
                return this.session.get();

              case 10:
                creds = _context2.sent;

                // update store with user data
                if (!isEmpty(creds)) {
                  this.dispatchAction({
                    type: UPDATE_USER,
                    payload: payload
                  });
                }

                this.dispatchAction({
                  type: EMAIL_SIGNUP_SUCCESS
                });
                return _context2.abrupt("return", payload);

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](2);
                // dispatch notification of invalid creds
                err = get(_context2.t0, 'response.data', {});
                errors = formatErrorResponse(err);
                _payload2 = {
                  errors: errors
                }; // update store with error

                this.dispatchAction({
                  type: EMAIL_SIGNUP_ERROR,
                  payload: _payload2
                });
                error = new Error('Email signup failure.');
                error.validationErrors = errors;
                throw error;

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 16]]);
      }));

      function emailSignUp(_x3) {
        return _emailSignUp.apply(this, arguments);
      }

      return emailSignUp;
    }()
  }, {
    key: "emailSignIn",
    value: function () {
      var _emailSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(body) {
        var _this$endpointConfig4, base, _this$endpointConfig5, method, path, formatBody, formatSuccessResponse, formatErrorResponse, resp, data, payload, err, errors, _payload3, error;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$endpointConfig4 = this.endpointConfig, base = _this$endpointConfig4.base, _this$endpointConfig5 = _this$endpointConfig4.emailSignIn, method = _this$endpointConfig5.method, path = _this$endpointConfig5.path, formatBody = _this$endpointConfig5.formatBody, formatSuccessResponse = _this$endpointConfig5.formatSuccessResponse, formatErrorResponse = _this$endpointConfig5.formatErrorResponse;
                this.dispatchAction({
                  type: EMAIL_SIGNIN_START
                });
                _context3.prev = 2;
                _context3.next = 5;
                return this[method]("".concat(base).concat(path), formatBody(body));

              case 5:
                resp = _context3.sent;
                data = get(resp, 'data', {});
                payload = formatSuccessResponse(data); // update store with user data

                this.dispatchAction({
                  type: UPDATE_USER,
                  payload: payload
                });
                this.dispatchAction({
                  type: EMAIL_SIGNIN_SUCCESS
                });
                return _context3.abrupt("return", payload);

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](2);
                // dispatch notification of invalid creds
                err = get(_context3.t0, 'response.data', {});
                errors = formatErrorResponse(err);
                _payload3 = {
                  errors: errors
                }; // update store with error

                this.dispatchAction({
                  type: EMAIL_SIGNIN_ERROR,
                  payload: _payload3
                });
                error = new Error('Email sign-in failure.');
                error.validationErrors = errors;
                throw error;

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 13]]);
      }));

      function emailSignIn(_x4) {
        return _emailSignIn.apply(this, arguments);
      }

      return emailSignIn;
    }()
  }, {
    key: "signOut",
    value: function () {
      var _signOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$endpointConfig6, base, _this$endpointConfig7, method, path, formatErrorResponse, err, errors, payload;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$endpointConfig6 = this.endpointConfig, base = _this$endpointConfig6.base, _this$endpointConfig7 = _this$endpointConfig6.signOut, method = _this$endpointConfig7.method, path = _this$endpointConfig7.path, formatErrorResponse = _this$endpointConfig7.formatErrorResponse;
                this.dispatchAction({
                  type: SIGN_OUT_START
                });
                _context4.prev = 2;
                _context4.next = 5;
                return this[method]("".concat(base).concat(path));

              case 5:
                this.dispatchAction({
                  type: SIGN_OUT_SUCCESS
                });
                _context4.next = 14;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](2);
                // dispatch notification of sign-out failure
                err = get(_context4.t0, 'response.data', {});
                errors = formatErrorResponse(err);
                payload = {
                  errors: errors
                }; // update store with error

                this.dispatchAction({
                  type: SIGN_OUT_ERROR,
                  payload: payload
                });

              case 14:
                _context4.next = 16;
                return this.session.clear();

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 8]]);
      }));

      function signOut() {
        return _signOut.apply(this, arguments);
      }

      return signOut;
    }()
  }, {
    key: "oAuthSignIn",
    value: function () {
      var _oAuthSignIn = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(provider) {
        var w,
            _this$endpointConfig8,
            base,
            oAuthSignIn,
            url,
            oAuthWindow,
            payload,
            _args5 = arguments;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                w = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : window;
                _this$endpointConfig8 = this.endpointConfig, base = _this$endpointConfig8.base, oAuthSignIn = _this$endpointConfig8.oAuthSignIn;
                url = "".concat(this.defaults.baseURL, "/").concat(base).concat(oAuthSignIn[provider]);
                this.dispatchAction({
                  type: OAUTH_SIGNIN_START
                });
                _context5.prev = 4;
                oAuthWindow = new OAuthBrowserWindow({
                  url: url,
                  provider: provider,
                  session: this.session,
                  w: w
                });
                _context5.next = 8;
                return oAuthWindow.hasAuthenticated;

              case 8:
                _context5.next = 10;
                return this.validateToken();

              case 10:
                payload = _context5.sent;
                this.dispatchAction({
                  type: OAUTH_SIGNIN_SUCCESS
                });
                return _context5.abrupt("return", payload);

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](4);
                this.dispatchAction({
                  type: OAUTH_SIGNIN_ERROR
                });
                throw new Error('OAuth sign-in failure.');

              case 19:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 15]]);
      }));

      function oAuthSignIn(_x5) {
        return _oAuthSignIn.apply(this, arguments);
      }

      return oAuthSignIn;
    }()
  }, {
    key: "passwordResetRequest",
    value: function () {
      var _passwordResetRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(body) {
        var _this$endpointConfig9, base, _this$endpointConfig10, method, path, formatBody, formatErrorResponse, err, errors, payload, error;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this$endpointConfig9 = this.endpointConfig, base = _this$endpointConfig9.base, _this$endpointConfig10 = _this$endpointConfig9.passwordResetRequest, method = _this$endpointConfig10.method, path = _this$endpointConfig10.path, formatBody = _this$endpointConfig10.formatBody, formatErrorResponse = _this$endpointConfig10.formatErrorResponse;
                this.dispatchAction({
                  type: PASSWORD_RESET_REQUEST_START
                });
                _context6.prev = 2;
                _context6.next = 5;
                return this[method]("".concat(base).concat(path), formatBody(_objectSpread({
                  config_name: this.userType
                }, body)));

              case 5:
                // dispatch success action
                this.dispatchAction({
                  type: PASSWORD_RESET_REQUEST_SUCCESS
                });
                return _context6.abrupt("return", true);

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](2);
                // dispatch notification of invalid creds
                err = get(_context6.t0, 'response.data', {});
                errors = formatErrorResponse(err);
                payload = {
                  errors: errors
                }; // update store with error

                this.dispatchAction({
                  type: PASSWORD_RESET_REQUEST_ERROR,
                  payload: payload
                });
                error = new Error('Password reset request failure.');
                error.validationErrors = errors;
                throw error;

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 9]]);
      }));

      function passwordResetRequest(_x6) {
        return _passwordResetRequest.apply(this, arguments);
      }

      return passwordResetRequest;
    }()
  }, {
    key: "updatePassword",
    value: function () {
      var _updatePassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(body) {
        var _this$endpointConfig11, base, _this$endpointConfig12, method, path, formatBody, formatErrorResponse, err, errors, payload, error;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this$endpointConfig11 = this.endpointConfig, base = _this$endpointConfig11.base, _this$endpointConfig12 = _this$endpointConfig11.passwordUpdate, method = _this$endpointConfig12.method, path = _this$endpointConfig12.path, formatBody = _this$endpointConfig12.formatBody, formatErrorResponse = _this$endpointConfig12.formatErrorResponse;
                this.dispatchAction({
                  type: PASSWORD_UPDATE_START
                });
                _context7.prev = 2;
                _context7.next = 5;
                return this[method]("".concat(base).concat(path), formatBody(_objectSpread({
                  config_name: this.userType
                }, body)));

              case 5:
                // dispatch success action
                this.dispatchAction({
                  type: PASSWORD_UPDATE_SUCCESS
                });
                return _context7.abrupt("return", true);

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](2);
                // dispatch notification of invalid creds
                err = get(_context7.t0, 'response.data', {});
                errors = formatErrorResponse(err);
                payload = {
                  errors: errors
                }; // update store with error

                this.dispatchAction({
                  type: PASSWORD_UPDATE_ERROR,
                  payload: payload
                });
                error = new Error('Password update failure.');
                error.validationErrors = errors;
                throw error;

              case 18:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 9]]);
      }));

      function updatePassword(_x7) {
        return _updatePassword.apply(this, arguments);
      }

      return updatePassword;
    }()
  }]);

  return AuthClient;
}(Axios);

export { AuthClient as default };